























































import {Component, Prop, Emit, Watch} from "vue-property-decorator";
import basicPage from "@/layouts/basicPage.vue";
import SearchInput from "@/components/searchInput.vue";
import {EMPTY_ARRAY, EMPTY_OBJECT} from "@/lib/appconst";
import CBreadcrumb from "@/components/cBreadcrumb.vue";

@Component({
    name: 'primaryPage',
    components: {CBreadcrumb, SearchInput, basicPage}
})
export default class primaryPage extends basicPage {
    @Prop({type: String, default: ''}) title: string;
    @Prop({type: String, default: ''}) subTitle: string;
    @Prop({type: String, default: ''}) keywords: string;
    @Prop({type: Array, default: EMPTY_ARRAY}) routes: any;
    @Prop({type: Object, default: EMPTY_OBJECT}) routeTokens: any;

    // inputVal: string = this.keywords;

    basePath = '';
    defRoutes: any[] = [{
        path: 'globalList',
        breadcrumbName: '首页'
    }];

    get rRoutes() {
        return this.defRoutes.concat(this.routes);
    }

    get lastRouteName() {
        let ret = '';
        let lastRoute = this.rRoutes[this.rRoutes.length - 1];
        if (lastRoute) {
            ret = lastRoute.breadcrumbName
        }
        return ret;
    }

    // @Watch('keywords')
    // handleKeyWordsChange(newVal: string, oldVal: string) {
    //     if (newVal !== oldVal) {
    //         debugger
    //         this.inputVal = newVal || '';
    //     }
    // }

    //关键字搜索
    @Emit('search')
    handleSearchBase(inputVal: string) {
        return inputVal;
    }
}
